require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[26],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-globaltoast{position:fixed;top:16px;right:16px;z-index:9000;background:#fff}.ba-common-globaltoast.is-not-found{display:none}.ba-common-globaltoast.is-stackable{position:relative;margin-bottom:8px;top:auto;right:auto}.ba-common-globaltoast.bx--toast-notification .bx--toast-notification__subtitle{color:#161616}.ba-common-globaltoast.bx--toast-notification .bx--toast-notification__close-icon{fill:#161616}.ba-common-globaltoast.bx--toast-notification .bx--toast-notification__details{color:#161616}", ""]);

// exports
exports.locals = {
	"globalToastClassName": "\"ba-common-globaltoast\""
};

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-globaltoastcontainer{z-index:9000;position:fixed;width:auto}", ""]);

// exports
exports.locals = {
	"globalToastContainerClassName": "\"ba-common-globaltoastcontainer\""
};

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactDom = __webpack_require__(11);

var _baUiCarbon = __webpack_require__(9);

var _globaltoast = _interopRequireDefault(__webpack_require__(329));

var _StringResource = _interopRequireDefault(__webpack_require__(330));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const globalToastClassName = _globaltoast.default.globalToastClassName.replace(/"/g, '');

function getStatusIconText(statusType, iconText) {
  if (iconText == null) {
    switch (statusType) {
      case 'info':
        return _StringResource.default.get('information');

      case 'success':
        return _StringResource.default.get('success');

      case 'warning':
        return _StringResource.default.get('warning');

      case 'error':
        return _StringResource.default.get('error');

      default:
        return iconText;
    }
  }

  return iconText;
}

class GlobalToast extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_onClose", e => {
      const {
        onClose
      } = this.props;
      onClose && onClose(e);
    });
    (0, _defineProperty2.default)(this, "_createNode", () => {
      const {
        statusType,
        contentString,
        children,
        closeText,
        className,
        style,
        statusIconText,
        timedDismiss,
        targetId,
        stackable,
        milliseconds
      } = this.props;
      const dataTid = this.props['data-tid']; // eslint-disable-line react/prop-types

      const statusText = getStatusIconText(statusType, statusIconText);
      const targeted = targetId ? ' is-targeted' : '';
      const foundTarget = document.getElementById(targetId) && targetId || !targetId ? '' : ' is-not-found';
      return /*#__PURE__*/_react.default.createElement(_baUiCarbon.ToastNotification, {
        caption: null,
        title: "",
        iconDescription: closeText,
        statusIconDescription: statusText,
        subtitle: contentString,
        timeout: timedDismiss ? milliseconds : null,
        className: `${globalToastClassName} ${className} ${targeted} ${foundTarget} ${stackable ? 'is-stackable' : ''}`,
        kind: statusType,
        style: style,
        onCloseButtonClick: this._onClose,
        role: "alert",
        "data-tid": dataTid
      }, contentString ? null : children);
    });
    this.timerId = null;
  }

  render() {
    const {
      targetId,
      stackable
    } = this.props;
    return stackable ? this._createNode() : (0, _reactDom.createPortal)(this._createNode(), document.getElementById(targetId) || document.body);
  }

}

exports.default = GlobalToast;
(0, _defineProperty2.default)(GlobalToast, "propTypes", {
  statusType: _propTypes.default.oneOf(['info', 'success', 'warning', 'error']),
  children: _propTypes.default.node,
  contentString: _propTypes.default.string,
  onClose: _propTypes.default.func,
  closeText: _propTypes.default.string,
  statusIconText: _propTypes.default.string,
  timedDismiss: _propTypes.default.bool,
  milliseconds: _propTypes.default.number,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  targetId: _propTypes.default.string,
  stackable: _propTypes.default.bool
});
(0, _defineProperty2.default)(GlobalToast, "defaultProps", {
  statusType: 'success',
  contentString: '',
  timedDismiss: false,
  milliseconds: 4000,
  closeText: _StringResource.default.get('close'),
  statusIconText: null,
  className: '',
  style: {},
  targetId: '',
  stackable: false
});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(328);


/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _GlobalToast = _interopRequireDefault(__webpack_require__(173));

exports.default = _GlobalToast.default;
exports.GlobalToast = _GlobalToast.default;

var _GlobalToastContainer = _interopRequireDefault(__webpack_require__(332));

exports.GlobalToastContainer = _GlobalToastContainer.default;

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_globaltoast_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(109);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_globaltoast_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_globaltoast_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_globaltoast_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_globaltoast_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _utils = __webpack_require__(5);

var _GlobalToastResources = _interopRequireDefault(__webpack_require__(331));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_GlobalToastResources.default);

exports.default = _default;

/***/ }),

/***/ 331:
/***/ (function(module, exports) {

var amdi18n={"__root":{"close":"Close","information":"Information","success":"Success","warning":"Warning","error":"Error"},"__cs":{"close":"Zavřít","information":"Informace","success":"Úspěch","warning":"Varování","error":"Chyba"},"__da":{"close":"Luk","information":"Information","success":"Udført","warning":"Advarsel","error":"Fejl"},"__de":{"close":"Schließen","information":"Information","success":"Erfolg","warning":"Warnung","error":"Fehler"},"__es":{"close":"Cerrar","information":"Información","success":"Correcto","warning":"Aviso","error":"Error"},"__fi":{"close":"Sulje","information":"Tiedot","success":"Onnistui","warning":"Varoitus","error":"Virhe"},"__fr":{"close":"Fermer","information":"Information","success":"Succès","warning":"Avertissement","error":"Erreur"},"__hr":{"close":"Zatvori","information":"Informacije","success":"Uspješno","warning":"Upozorenje","error":"Greška"},"__hu":{"close":"Bezárás","information":"Információ","success":"Sikeres","warning":"Figyelmeztetés","error":"Hiba"},"__it":{"close":"Chiudi","information":"Informazioni","success":"Esito positivo","warning":"Avvertenza","error":"Errore"},"__ja":{"close":"閉じる","information":"情報","success":"完了","warning":"警告","error":"エラー"},"__kk":{"close":"Жабу","information":"Information","success":"Success","warning":"Warning","error":"Error"},"__ko":{"close":"닫기","information":"정보","success":"성공","warning":"경고","error":"오류"},"__nb":{"close":"Lukk","information":"Informasjon","success":"Vellykket","warning":"Advarsel","error":"Feil"},"__nl":{"close":"Sluiten","information":"Informatie","success":"Gelukt","warning":"Waarschuwing","error":"Fout"},"__no":{"close":"Lukk","information":"Informasjon","success":"Vellykket","warning":"Advarsel","error":"Feil"},"__pl":{"close":"Zamknij","information":"Informacja","success":"Pomyślne wykonanie","warning":"Ostrzeżenie","error":"Błąd"},"__pt":{"close":"Fechar","information":"Informações","success":"Evento","warning":"Aviso","error":"Erro"},"__pt-br":{"close":"Fechar","information":"Informações","success":"Evento","warning":"Aviso","error":"Erro"},"__ro":{"close":"Închidere","information":"Informaţii","success":"Succes","warning":"Avertisment","error":"Eroare"},"__ru":{"close":"Закрыть","information":"Информация","success":"Успешно","warning":"Предупреждение","error":"Ошибка"},"__sl":{"close":"Zapri","information":"Informacije","success":"Uspešno","warning":"Opozorilo","error":"Napaka"},"__sv":{"close":"Stäng","information":"Information","success":"Klar","warning":"Varning","error":"Fel"},"__th":{"close":"ปิด","information":"ข้อมูล","success":"สำเร็จ","warning":"คำเตือน","error":"ข้อผิดพลาด"},"__tr":{"close":"Kapat","information":"Bilgi","success":"Başarılı","warning":"Uyarı","error":"Hata"},"__zh":{"close":"关闭","information":"信息","success":"成功","warning":"警告","error":"错误"},"__zh-cn":{"close":"关闭","information":"信息","success":"成功","warning":"警告","error":"错误"},"__zh-hk":{"close":"關閉","information":"資訊","success":"成功","warning":"警告","error":"錯誤"},"__zh-mo":{"close":"關閉","information":"資訊","success":"成功","warning":"警告","error":"錯誤"},"__zh-sg":{"close":"关闭","information":"信息","success":"成功","warning":"警告","error":"错误"},"__zh-tw":{"close":"關閉","information":"資訊","success":"成功","warning":"警告","error":"錯誤"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactDom = __webpack_require__(11);

var _GlobalToast = _interopRequireDefault(__webpack_require__(173));

var _globaltoastcontainer = _interopRequireDefault(__webpack_require__(333));

const globalToastContainerClassName = _globaltoastcontainer.default.globalToastContainerClassName.replace(/"/g, '');

class GlobalToastContainer extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_coordinateAdjustor", () => {
      const {
        xOffset,
        yOffset,
        position
      } = this.props;
      const result = {};

      switch (position) {
        case 'upperLeft':
          result.left = xOffset;
          result.top = yOffset;
          break;

        case 'upperRight':
          result.right = xOffset;
          result.top = yOffset;
          break;

        default:
          break;
      }

      return result;
    });
  }

  render() {
    const coordinate = this._coordinateAdjustor();

    const {
      className,
      targetId,
      toasts
    } = this.props;
    return (0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
      style: { ...coordinate
      },
      className: `${globalToastContainerClassName} ${className}`
    }, toasts && toasts.map(toastProp => /*#__PURE__*/_react.default.createElement(_GlobalToast.default, toastProp))), document.getElementById(targetId) || document.body);
  }

}

exports.default = GlobalToastContainer;
(0, _defineProperty2.default)(GlobalToastContainer, "propTypes", {
  position: _propTypes.default.oneOf(['upperLeft', 'upperRight']),
  toasts: _propTypes.default.array,
  xOffset: _propTypes.default.number,
  yOffset: _propTypes.default.number,
  targetId: _propTypes.default.string,
  className: _propTypes.default.string
});
(0, _defineProperty2.default)(GlobalToastContainer, "defaultProps", {
  position: 'upperRight',
  xOffset: 0,
  yOffset: 0
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_globaltoastcontainer_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(110);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_globaltoastcontainer_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_globaltoastcontainer_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_globaltoastcontainer_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_globaltoastcontainer_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ })

},[[327,0]]]);
});